import { render, staticRenderFns } from "./actor.vue?vue&type=template&id=103c9270&scoped=true&"
import script from "./actor.vue?vue&type=script&lang=js&"
export * from "./actor.vue?vue&type=script&lang=js&"
import style0 from "./actor.vue?vue&type=style&index=0&id=103c9270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103c9270",
  null
  
)

export default component.exports